export class EidosBaseList {
  code: string;
  description: string;

  constructor() {
    this.code='';
    this.description='';
  }
}
